module.exports = __webpack_public_path__ + "img/login-4.e5f1dd1d.png";